// theme-system/ComponentRegistry.js
// Maps block names to lazy-loaded React components
// Schema references these by exact key name - no template concept

import { lazy } from 'react';

// All UI blocks - named by purpose/style, not by template
const ComponentRegistry = {
  "Placeholder": null,
  // === HEADERS ===
  "Header": lazy(() => import('components/themesystem/Header')),
  
  // === FOOTERS ===
  "Footer": lazy(() => import('components/themesystem/Footer')),
  
  // === CONTENT BLOCKS ===
  // "HeroBanner/riocity": lazy(() => import('components/custom/HomePageBanner')),
  // "MarqueAnnoucement/riocity": lazy(() => import('components/custom/MarqueAnnoucement')),
  // "LiveTransactions/riocity": lazy(() => import('components/custom/LiveTransactions')),
  // "RecentBigWin/riocity": lazy(() => import('components/custom/RecentBigWin')),
  // "HotProviders/riocity": lazy(() => import('components/custom/HotProviders')),
  // "ProviderList/riocity": lazy(() => import('components/custom/ProviderList')),
  // "CustomGrid/riocity": lazy(() => import('components/custom/HomepageCustomGrid')),
  // "CustomSection/riocity": lazy(() => import('components/custom/CustomHtml')),

  // "HeroBanner/gembet": lazy(() => import('components/themesystem/gembet/HeroBanner')),
  // "LiveTransactions/gembet": lazy(() => import('components/themesystem/gembet/LiveTransactionsSection')),
  // "GameGrid/gembet": lazy(() => import('components/themesystem/gembet/GameGrid')),

  "GameList/riocity": lazy(() => import('components/themesystem/riocity/GameList')),
  "GameList/gembet": lazy(() => import('components/themesystem/gembet/GameList')),
  "GameList/caelo": lazy(() => import('components/themesystem/caelo/GameList')),
  "GameList/netflix": lazy(() => import('components/themesystem/netflix/GameList')),
  "GameList/sapphire": lazy(() => import('components/themesystem/sapphire/GameList')),

  "Promotion/riocity": lazy(() => import('components/themesystem/riocity/Promotion')),
  "Promotion/gembet": lazy(() => import('components/themesystem/gembet/PromotionV2')),
  "Promotion/caelo": lazy(() => import('components/themesystem/caelo/PromotionV3')),
  "Promotion/sapphire": lazy(() => import('components/themesystem/sapphire/PromotionV4')),
  "Promotion/netflix": lazy(() => import('components/themesystem/netflix/PromotionV5')),

  "PromotionInfo/gembet": lazy(() => import('components/themesystem/PromotionInfoRedirect')),
  "PromotionInfo/caelo": lazy(() => import('components/themesystem/PromotionInfoRedirect')),
  "PromotionInfo/sapphire": lazy(() => import('components/themesystem/PromotionInfoRedirect')),
  "PromotionInfo/netflix": lazy(() => import('components/themesystem/PromotionInfoRedirect')),

  "InformationCenter/riocity": lazy(() => import('pages/template_1/home/InformationCenter')),
  "InformationCenter/gembet": lazy(() => import('components/themesystem/gembet/InformationCenterV2')),
  "InformationCenter/caelo": lazy(() => import('components/themesystem/caelo/InformationCenterV3')),
  "InformationCenter/sapphire": lazy(() => import('components/themesystem/sapphire/InformationCenterV4')),
  "InformationCenter/netflix": lazy(() => import('components/themesystem/netflix/InformationCenterV5')),

  "Settings/riocity": lazy(() => import('pages/template_1/home/Settings')),
  "Settings/gembet": lazy(() => import('components/themesystem/gembet/SettingsV2')),
  "Settings/caelo": lazy(() => import('@/components/themesystem/caelo/SettingsV3')),
  "Settings/sapphire": lazy(() => import('@/components/themesystem/sapphire/SettingsV4')),
  "Settings/netflix": lazy(() => import('components/themesystem/netflix/SettingsV5')),

  "DepositWithdrawal/riocity": lazy(() => import('pages/template_1/transaction/DepositWithdrawalPage')),
  "DepositWithdrawal/gembet": lazy(() => import('components/themesystem/gembet/DepositWithdrawalPagev2')),
  "DepositWithdrawal/caelo": lazy(() => import('@/components/themesystem/caelo/DepositWithdrawalPagev3')),
  "DepositWithdrawal/sapphire": lazy(() => import('@/components/themesystem/sapphire/DepositWithdrawalPagev4')),
  "DepositWithdrawal/netflix": lazy(() => import('components/themesystem/netflix/transaction/DepositWithdrawalPagev5')),

  "Referral/riocity": lazy(() => import('pages/template_1/home/Referral')),
  "Referral/gembet": lazy(() => import('components/themesystem/gembet/ReferralV2')),
  "Referral/caelo": lazy(() => import('@/components/themesystem/caelo/ReferralV3')),
  "Referral/sapphire": lazy(() => import('@/components/themesystem/sapphire/ReferralV4')),
  "Referral/netflix": lazy(() => import('components/themesystem/netflix/ReferralV5')),

  "Rebate/riocity": lazy(() => import('pages/template_1/home/Rebate')),
  "Rebate/gembet": lazy(() => import('components/themesystem/gembet/RebateV2')),
  "Rebate/caelo": lazy(() => import('@/components/themesystem/caelo/RebateV3')),
  "Rebate/sapphire": lazy(() => import('@/components/themesystem/sapphire/RebateV4')),
  "Rebate/netflix": lazy(() => import('components/themesystem/netflix/RebateV5')),

  "Vip/riocity": lazy(() => import('pages/template_1/home/Vip')),
  "Vip/gembet": lazy(() => import('components/themesystem/gembet/VipV2')),
  "Vip/caelo": lazy(() => import('@/components/themesystem/caelo/VipV3')),
  "Vip/sapphire": lazy(() => import('@/components/themesystem/sapphire/VipV4')),
  "Vip/netflix": lazy(() => import('components/themesystem/netflix/VipV5')),

  "MlmStageCommission/riocity": lazy(() => import('components/themesystem/gembet/MlmStageCommissionV2.js')),
  "MlmStageCommission/gembet": lazy(() => import('components/themesystem/gembet/MlmStageCommissionV2.js')),
  "MlmStageCommission/netflix": lazy(() => import('components/themesystem/netflix/MlmStageCommissionV5.js')),

  "RecentGames/riocity": lazy(() => import('pages/template_1/game/RecentGames')),
  "RecentGames/gembet": lazy(() => import('components/themesystem/gembet/RecentGames')),
  "RecentGames/caelo": lazy(() => import('components/themesystem/caelo/RecentGames')),
  "RecentGames/sapphire": lazy(() => import('components/themesystem/sapphire/RecentGames')),
  "RecentGames/netflix": lazy(() => import('components/themesystem/netflix/RecentGames')),

  "HotGames/riocity": lazy(() => import('pages/template_1/game/HotGames')),
  "HotGames/gembet": lazy(() => import('components/themesystem/gembet/HotGames')),
  "HotGames/caelo": lazy(() => import('components/themesystem/caelo/HotGames')),
  "HotGames/sapphire": lazy(() => import('components/themesystem/sapphire/HotGames')),
  "HotGames/netflix": lazy(() => import('components/themesystem/netflix/HotGames')),

  "Leaderboard/riocity": lazy(() => import('@/components/themesystem/riocity/Leaderboard')),
  "Leaderboard/caelo": lazy(() => import('@/components/themesystem/caelo/Leaderboard')),

  "HotProviders/riocity": lazy(() => import('pages/template_1/game/HotProviders')),
  "HotProviders/gembet": lazy(() => import('components/themesystem/gembet/HotProviders')),
  "HotProviders/caelo": lazy(() => import('components/themesystem/caelo/HotProviders')),
  "HotProviders/sapphire": lazy(() => import('components/themesystem/sapphire/HotProviders')),
  "HotProviders/netflix": lazy(() => import('components/themesystem/netflix/HotProviders')),

  "GameLobby/riocity": lazy(() => import('pages/template_1/game/GameLobby')),
  "GameLobby/gembet": lazy(() => import('components/themesystem/gembet/GameLobby')),
  "GameLobby/caelo": lazy(() => import('components/themesystem/caelo/GameLobby')),
  "GameLobby/sapphire": lazy(() => import('components/themesystem/sapphire/GameLobby')),
  "GameLobby/netflix": lazy(() => import('components/themesystem/netflix/GameLobby')),

  "GamePage/riocity": lazy(() => import('pages/template_1/game/GamePage2')),
  "GamePage/gembet": lazy(() => import('components/themesystem/gembet/GamePage2')),
  "GamePage/caelo": lazy(() => import('components/themesystem/caelo/GamePage2')),
  "GamePage/sapphire": lazy(() => import('components/themesystem/sapphire/GamePage2')),
  "GamePage/netflix": lazy(() => import('components/themesystem/netflix/GamePage2')),

  // Add more blocks as they are created...
};

/**
 * Get a component by its registry key
 * @param {string} type - Component key from schema (e.g., "HeaderGemBet")
 * @returns {React.LazyExoticComponent|null}
 */
export function getComponent(type, skin) {
  let component = null;
  if(type === "Header" || type === "Footer") {
    component = ComponentRegistry[type];
    if (!hasComponent(type)) {
      console.warn(
        `[ComponentRegistry] Unknown component: "${type}".`
      );
      return null;
    }
  } else {
    component = ComponentRegistry[`${type}/${skin}`];

    if (!hasComponent(`${type}/${skin}`)) {
      console.warn(
        `[ComponentRegistry] Unknown component: "${type}/${skin}".`
      );
      return null;
    }
  }

  return component || null;
}

/**
 * Check if a component exists in the registry
 * @param {string} type - Component key
 * @returns {boolean}
 */
export function hasComponent(type) {
  return type in ComponentRegistry;
}

/**
 * Get list of all registered component names
 * @returns {string[]}
 */
export function getRegisteredComponents() {
  return Object.keys(ComponentRegistry);
}

export default ComponentRegistry;
